import React from 'react'

import PageHeader from 'app/KinerjaPage/components/PageHeader'
import KinerjaPerencanaanApp from 'app/KinerjaPage/pages/Perencanaan'
import KinerjaPerencanaanWaitingApprovalApp from 'app/KinerjaPage/pages/PerencanaanWaitingApproval'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { useAPIKinerja } from 'api/kinerja/useAPIKinerja'
import ContentProvider from 'app/KinerjaPage/components/ContentProvider'
import KinerjaPerencanaanApprovedApp from 'app/KinerjaPage/pages/PerencanaanApproved'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'
import type { Jenjang } from 'types/kinerja'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled']
    const isKinerjaPerencanaanEnabled = toggle?.['kinerja-perencanaan-enabled']
    const isDeleteSKPEnabled = toggle?.['kinerja-delete-perencanaan-enabled']

    if (!isKinerjaEnabled || !isKinerjaPerencanaanEnabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }

    return {
      props: {
        isDeleteSKPEnabled,
      },
    }
  },
})

const KinerjaPerencanaan = ({ isDeleteSKPEnabled }) => {
  const { data: { data: skp } = {}, isFetched: isSKPFetched } = useAPIKinerja()

  return (
    <ContentProvider jenjang={skp?.jenjang as Jenjang}>
      {['WAITING_APPROVAL', 'REVISED'].includes(skp?.status) ? (
        <KinerjaPerencanaanWaitingApprovalApp
          skp={skp}
          isSKPFetched={isSKPFetched}
        />
      ) : ['APPROVED', 'READY'].includes(skp?.status) ? (
        <KinerjaPerencanaanApprovedApp
          skp={skp}
          isSKPFetched={isSKPFetched}
          isDeleteSKPEnabled={isDeleteSKPEnabled}
        />
      ) : (
        <KinerjaPerencanaanApp skp={skp} isSKPFetched={isSKPFetched} />
      )}
    </ContentProvider>
  )
}

KinerjaPerencanaan.Layout = KinerjaLayout
KinerjaPerencanaan.layoutOpts = {
  hasHeader: true,
  className: 'text-default bg-gray-10 !max-w-full !h-full min-h-screen',
  header: PageHeader,
}

export default KinerjaPerencanaan
